import React from "react"

import Layout from "../../Components/Layout/Layout"
import PageTitle from "../../Components/Layout/PageTitle"
import { ProvisionContainer } from "../../Components/Style/Styles"
import { Policy } from "../../Config/Constant"

function Provision() {
  return (
    <Layout isNav={false} isFooter={true} isSearch={true}>
      <PageTitle title={`${Policy.Provision.title}`} />
      <ProvisionContainer>
        <h1>{Policy.Provision.title}</h1>
        <div className="inner">{Policy.Provision.content}</div>
      </ProvisionContainer>
    </Layout>
  )
}

export default Provision
